import { ClaimRequestRepository } from '../../domain/repositories/ClaimRequestRepository';

export class DuplicateClaimRequest {
    constructor(private repository: ClaimRequestRepository) {}

    async execute(claimRequestKey: string) {
        return await this.repository.duplicate(claimRequestKey);
    }
}
